// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_c8f5c4', '__Poppins_Fallback_c8f5c4'","fontStyle":"normal"},"className":"__className_c8f5c4","variable":"__variable_c8f5c4"};